import React from 'react';

export default () => {
  return <div>목표 관리</div>;
};
